import angular from 'angular';
import moment from 'angular-moment';

import ActivePowerService from '../../../../components/api/active_power/active_power.service';
import PowerFormatter from '../../../../components/logic/power-formatter/power-formatter.logic';
import DateUtil from '../../../../components/logic/date_util/date_util.module';
import chartConfig from './compare-graph-daily-active.config';

export class CompareGraphDailyActiveController {
  /*@ngInject*/
  constructor($filter, $interval, $scope, $q, moment, PowerFormatter, DateUtil, ActivePowerService) {
    this.$filter = $filter;
    this.$interval = $interval;
    this.$q = $q;
    this.moment = moment;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.ActivePowerService = ActivePowerService;

    this.categories = this.DateUtil.getXLabels;
    this.maxDate = moment().startOf('day').toDate();
    this.missingTimes = [];
    this.noCalculateTimes = [];
    this.graphUpdating = false;

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.selectedConfigs', () => this.updateGraph(this.targetDate));
    $scope.$watch('$ctrl.targetDate', () => this.updateGraph(this.targetDate));
  }

  $onInit() {
    this.timer = this.$interval(() => {
      this.updateGraph(this.targetDate);
    }, 300000);
  }

  updateGraph(targetDate) {
    if (this.chart) {
      this.chart.reflow();
    }

    if (this.selectedConfigs.length === 0) {
      return;
    }
    this.graphUpdating = true;
    this.resetSeries();

    const promises = [];

    for (let config of this.selectedConfigs) {
      promises.push(this.getActivePower(config, targetDate));
    }

    this.$q.all(promises).then(results => {
      for (let result of results) {
        this.addSeries(result.activePowers, result.config);
      }
      this.chart.redraw();
      this.chart.reflow();
      this.graphUpdating = false;
    });
  }

  getActivePower(config, targetDate) {
    const dateQuery = this.DateUtil.getActivePowerQueries(targetDate);
    const query = angular.extend({id: config.id}, dateQuery);

    return new Promise(resolve => {
      this.ActivePowerService.show(query, res => {
        const [activePowers, ,] = this.PowerFormatter.formatActivePowers(res.powers, this.categories, targetDate);
        resolve({activePowers, config});
      });
    });
  }

  addSeries(powers, config) {
    if (!powers) { return; }
    const graphData = this.categories.map((e, i) => {
      return [e, powers[i]];
    });
    this.chart.addSeries({
      name: config.pms_service_code,
      type: this.graphType,
      data: graphData
    }, false);
  }

  changeDate(diff) {
    if (diff) {
      this.updateTargetDate({targetDate: this.DateUtil.leapDate(this.targetDate, diff)});
    }
  }

  resetSeries() {
    if (!this.chart) {
      return;
    }
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
  }
}


export default angular.module('leptonApp.compareGraphDailyActive', [moment, PowerFormatter, DateUtil, ActivePowerService])
  .component('compareGraphDailyActive', {
    template: require('./compare-graph-daily-active.html'),
    controller: CompareGraphDailyActiveController,
    bindings: {
      selectedConfigs: '=',
      configIds: '=',
      graphType: '=',
      targetDate: '=',
      updateTargetDate: '&'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/active/daily/compare-graph-daily-active.component.js